<tc-availability-calendar
        [calendarEvents]="calendarEvents"
        [navConfig]="navConfig"
        [viewOptions]="viewOptions"
        [calendarPlugins]="calendarPlugins"
        (dateClick)="handleDateClick($event)"
        (sideNavItemClick)="filterSelectedEvents($event)"
        (eventClick)="eventClick($event)"
></tc-availability-calendar>
